module.exports = __webpack_public_path__ + "img/yishenhe.3e3fadb0.png";